import React from "react"
import { Link } from "gatsby"
import Subheader from "./subheader"
import { Nav, Button } from "react-bootstrap"
import ModalCennik from "./Modals/ModalCennik"
// import ModalCennik from "./Modals/ModalCennikPromo3week"

// import Logo from "../images/logo-new-small.svg"
import Logo from "../images/logo-new-bezdopisku.svg"
// import scrollTo from "gatsby-plugin-smoothscroll"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import InfoliniaNumbers from "./infolinia-numbers"

const Header = ({ siteTitle, siteDesc , menu}) => {

  const [modCennikShow, setModCennikShow] = React.useState(false);
  const [menuShow, setMenuShow] = React.useState(false)

  const handleClick = () => {
    !menuShow ? setMenuShow(true) : setMenuShow(false)
  }

 return (
   <>
     <Subheader />
     <header className={`page-header ${menuShow ? "fixed" : ""}`}>
       <div className="container pr-0 px-xl-3 px-xxl-5">
         <div className="d-flex justify-content-between align-items-center w-100 px-xxl-3 px-xxxl-5">
           <Link to="/" className="main-logo">
             <img
               src={Logo}
               alt="ORLEN Charge - stacje ładowania pojazdów elektrycznych"
               className="img-fluid"
             />
           </Link>

           <Button
             className={`hamburger hamburger--collapse navbar-toggler d-xl-none ${
               menuShow ? "is-active" : ""
             }`}
             onClick={() => handleClick()}
             aria-label="pokaż menu"
           >
             <span className="hamburger-box">
               <span className="hamburger-inner"></span>
             </span>
           </Button>

           <div
             className={`navi-holder justify-content-xl-end d-none d-xl-flex ${
               menuShow ? "fixed" : ""
             }`}
           >
             <Nav variant="pills">
             {/* <Nav.Item>
                 <AnchorLink
                   to="/lista-aktualnosci"
                   title={menu[5]}
                   className="nav-link"
                 />
               </Nav.Item> */}
               <Nav.Item>
                 <AnchorLink
                   to="/#oferta"
                   title={menu[0]}
                   className="nav-link"
                 />
               </Nav.Item>
               <Nav.Item>
                 <AnchorLink
                   to="/punkty-vitay"
                   title={menu[6]}
                   className="nav-link"
                 />
               </Nav.Item>
               <Nav.Item>
                 <AnchorLink
                   to="/#mapa-stacji"
                   title={menu[1]}
                   className="nav-link"
                 />
               </Nav.Item>
               <Nav.Item>
                 <Link to="/regulamin-promo" className="nav-link">
                   {menu[2]}
                 </Link>
               </Nav.Item>
               <Nav.Item>
                 <Link to="/cennik" className="nav-link">
                   {menu[3]}
                 </Link>
               </Nav.Item>
               {/* <Nav.Item>
                 <Nav.Link href="#" onClick={() => setModCennikShow(true)}>
                   {menu[3]}
                 </Nav.Link>
               </Nav.Item> */}
               <Nav.Item>
                 <AnchorLink to="/#faq" title={menu[4]} className="nav-link" />
               </Nav.Item>
             </Nav>

             <div className="col-12 col-sm-6 offset-sm-3 mt-5 mt-sm-3 d-md-none">
               <div className="infolinia w-100">
                 <div className="info-logo">
                   <span className="icon-infolinia"></span>
                 </div>
                 <InfoliniaNumbers />
               </div>
             </div>
           </div>
         </div>
       </div>
     </header>
     <ModalCennik show={modCennikShow} handleclose={() => setModCennikShow(false)} />
   </>
 )}

export default Header
